import { useEffect, useRef } from 'react'

type ScrollCondition = 'always' | 'outOfView'

const shouldScrollByCondition: Record<ScrollCondition, (scrollerRect: DOMRect, contentElementRect: DOMRect) => boolean> = {
  always: () => true,
  outOfView: (scrollerRect, contentElementRect) => {
    return contentElementRect.right > scrollerRect.right || contentElementRect.left < scrollerRect.left
  },
}

export default function useHorizontalScrollIntoView(
  selected?: string,
  options?: { scrollCondition?: ScrollCondition },
): [
  scroller: React.MutableRefObject<HTMLDivElement | null>,
  contentElements: React.MutableRefObject<{ [x: string]: HTMLElement }>,
] {
  const scroller = useRef<HTMLDivElement | null>(null)
  const stepElements = useRef<{ [x: string]: HTMLElement }>({})

  const scrollCondition = options?.scrollCondition || 'always'

  useEffect(() => {
    const scrollerELement = scroller.current
    if (scrollerELement && selected) {
      const scrollerRect = scrollerELement.getBoundingClientRect()
      const contentElementRect = stepElements.current[selected]?.getBoundingClientRect()
      const shouldScroll = shouldScrollByCondition[scrollCondition]

      if (scrollerRect && contentElementRect && scrollerELement.scrollWidth > scrollerRect.width && shouldScroll(scrollerRect, contentElementRect)) {
        // Adjust scroll to centre the element
        const currentCentre = contentElementRect.left + contentElementRect.width / 2
        const targetCentre = scrollerRect.left + scrollerRect.width / 2
        const scrollPosition = currentCentre - targetCentre
        scrollerELement.scrollBy({ left: scrollPosition, behavior: 'smooth' })
      }
    }
  }, [scrollCondition, selected])

  return [scroller, stepElements]
}
